export const isIE11 = !!globalThis.MSInputMethodContext && !!document.documentMode;